var map = {
	"./feelgood_plus.zip": "bd55",
	"./logo-feelgood-colored-linebreak.png": "0dd2",
	"./logo-feelgood-colored-linebreak.svg": "824a",
	"./logo-feelgood-colored.png": "8901",
	"./logo-feelgood-colored.svg": "bb37",
	"./logo-feelgood-light-linebreak.png": "bcd6",
	"./logo-feelgood-light-linebreak.svg": "718c",
	"./logo-feelgood-light.png": "7d43",
	"./logo-feelgood-light.svg": "70c4",
	"./logo-feelgood-plus.png": "cb0c",
	"./logo-feelgood-plus.svg": "7693",
	"./logo-feelgood-print.eps": "5b96",
	"./logo-feelgood-print.svg": "8e53",
	"./logo-feelgoodplus-tagline-english.png": "d280",
	"./logo-feelgoodplus-tagline-english.svg": "a8df",
	"./logo-feelgoodplus-tagline-swedish.png": "a7f5",
	"./logo-feelgoodplus-tagline-swedish.svg": "b26a",
	"./logos-feelgood.zip": "cd41",
	"./logotypes": "1164",
	"./logotypes.json": "1164"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d69f";